import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '../shared/shared.module';
import {PrlDashboardModule} from './prl-dashboard/prl-dashboard.module';
import {PrlAuthenticationModule} from './prl-authentication/prl-authentication.module';
import {PrlStatisticsModule} from './prl-statistics/prl-statistics.module';
import {PrlProfilesModule} from './prl-profiles/prl-profiles.module';
import {PrlAccountModule} from './prl-account/prl-account.module';
import {PrlFinanceModule} from './prl-finance/prl-finance.module';
import {PrlMarketingToolsModule} from './prl-marketing-tools/prl-marketing-tools.module';
import {PrlLanguageModule} from './prl-language/prl-language.module';
import {PrlInfoModule} from "./prl-info/prl-info.module";
import {PrlErrorPageModule} from './prl-error-page/prl-error-page.module';


@NgModule({
    imports: [
        SharedModule,
        CommonModule,
        PrlDashboardModule,
        PrlAuthenticationModule,
        PrlStatisticsModule,
        PrlProfilesModule,
        PrlAccountModule,
        PrlFinanceModule,
        PrlMarketingToolsModule,
        PrlLanguageModule,
        PrlInfoModule,
        PrlErrorPageModule
    ]
})
export class ViewModule {
}
